import { render, staticRenderFns } from "./CustomerInteractionReport.vue?vue&type=template&id=55337848&scoped=true"
import script from "./CustomerInteractionReport.vue?vue&type=script&lang=js"
export * from "./CustomerInteractionReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55337848",
  null
  
)

export default component.exports